import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import beach from './images/sale/beach.jpg'
import bech from './images/sale/bech.jpg'
import hall from './images/sale/hall.jpg'
import kitchen from './images/sale/kitchen.jpg'
import constr from './images/sale/constr.jpg'
import construction from './images/sale/construction.jpg'
import cylander from './images/sale/cylander.jpg'
import { ImLocation2 } from 'react-icons/im';
import { Link } from 'react-router-dom';

const TrackSales = () => {
    return (
        <>
            <div className="md:py-[3rem]">

                <div class="grid grid-cols-12 md:mx-[6rem] mx-5 gap-5 md:py-6">

                    <div class="md:col-span-4 col-span-12 md:my-0 my-10  ">

                        <div className='relative'>
                            <h1 className='mx-[10px] my-[10px] text-[12px] absolute z-10 text-[#004a8b] font-[600] bg-[#EAF1F7] px-[12px] py-[9px] text-center justify-center tracking-widest'>$1,750,000</h1>
                            <Carousel showThumbs={false} showStatus={false} showIndicators={false}>

                                <div>
                                    <img src={beach} alt="image1" />
                                </div>
                                <div>
                                    <img src={bech} alt="image2" />
                                </div>
                                <div>
                                    <img src={hall} alt="image3" />
                                </div>
                                <div>
                                    <img src={kitchen} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="/Slider">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>EMERALD</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>376 Mt Dangar Road</h1></div>
                        <div className=" mx-1 text-gray-400 "><h1>4386 ha</h1></div>

                    </div>

                    <div class="md:col-span-4 col-span-12 md:my-0 my-10 ">

                        <div className='relative'>
                            <h1 className='mx-[10px] my-[10px] text-[12px] absolute z-10 text-[#004a8b] font-[600] bg-[#EAF1F7] px-[12px] py-[9px] text-center justify-center tracking-widest'>CONTACT AGENT</h1>
                            <Carousel showThumbs={false} showStatus={false} showIndicators={false}>

                                <div>
                                    <img src={constr} alt="image1" />
                                </div>
                                <div>
                                    <img src={construction} alt="image2" />
                                </div>
                                <div>
                                    <img src={cylander} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="/Slider">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>EMERALD</h1>
                        </div>
                        <div className=" mx-1 font-black"><h1>376 Mt Dangar Road</h1></div>
                        <div className=" mx-1 text-gray-400"><h1>4386 ha</h1></div>

                    </div>

                    <div class="md:col-span-4 col-span-12 md:my-0 my-10 ">

                        <div className='relative'>
                            <h1 className='mx-[10px] my-[10px] text-[12px] absolute z-10 text-[#004a8b] font-[600] bg-[#EAF1F7] px-[12px] py-[9px] text-center justify-center tracking-widest'>$5,900,000</h1>
                            <Carousel showThumbs={false} showStatus={false} showIndicators={false}>

                                <div>
                                    <img src={bech} alt="image1" />
                                </div>
                                <div>
                                    <img src={cylander} alt="image2" />
                                </div>
                                <div>
                                    <img src={hall} alt="image3" />
                                </div>
                                <div>
                                    <img src={construction} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="/Slider">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>EMERALD</h1>
                        </div>
                        <div className=" mx-1 font-black"><h1>376 Mt Dangar Road</h1></div>
                        <div className="mx-1 text-gray-400 "><h1>4386 ha</h1></div>

                    </div>
                </div>

                <div class="grid grid-cols-12 md:mx-[6rem] mx-5 gap-5 md:py-4">

                    <div class="md:col-span-4 col-span-12 md:my-0 my-10  ">

                        <div className='relative'>
                            <h1 className='mx-[10px] my-[10px] text-[12px] absolute z-10 text-[#004a8b] font-[600] bg-[#EAF1F7] px-[12px] py-[9px] text-center justify-center tracking-widest'>$3,750,000</h1>
                            <Carousel showThumbs={false} showStatus={false} showIndicators={false}>

                                <div>
                                    <img src={kitchen} alt="image2" />
                                </div>
                                <div>
                                    <img src={beach} alt="image1" />
                                </div>
                                <div>
                                    <img src={hall} alt="image3" />
                                </div>
                                <div>
                                    <img src={bech} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="/Slider">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>ERALD</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>376 Mt Aangar Road</h1></div>
                        <div className=" mx-1 text-gray-400 "><h1>4336 ha</h1></div>

                    </div>

                    <div class="md:col-span-4 col-span-12 md:my-0 my-10 ">

                        <div className='relative'>
                            <h1 className='mx-[10px] my-[10px] text-[12px] absolute z-10 text-[#004a8b] font-[600] bg-[#EAF1F7] px-[12px] py-[8px] text-center justify-center tracking-widest'>EOI</h1>
                            <Carousel showThumbs={false} showStatus={false} showIndicators={false}>

                                <div>
                                    <img src={cylander} alt="image3" />
                                </div>
                                <div>
                                    <img src={constr} alt="image1" />
                                </div>
                                <div>
                                    <img src={construction} alt="image2" />
                                </div>

                            </Carousel>
                            <a href="/Slider">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>EMER</h1>
                        </div>
                        <div className=" mx-1 font-black"><h1>776 Mt Dangar Road</h1></div>
                        <div className=" mx-1 text-gray-400"><h1>8786 ha</h1></div>

                    </div>

                    <div class="md:col-span-4 col-span-12 md:my-0 my-10 ">

                        <div className='relative'>
                            <h1 className='mx-[10px] my-[10px] text-[12px] absolute z-10 text-[#004a8b] font-[600] bg-[#EAF1F7] px-[12px] py-[9px] text-center justify-center tracking-widest'>FOR SALE BY EOI</h1>
                            <Carousel showThumbs={false} showStatus={false} showIndicators={false}>

                                <div>
                                    <img src={hall} alt="image3" />
                                </div>
                                <div>
                                    <img src={bech} alt="image1" />
                                </div>
                                <div>
                                    <img src={cylander} alt="image2" />
                                </div>

                                <div>
                                    <img src={construction} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="/Slider">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>EMERALD</h1>
                        </div>
                        <div className=" mx-1 font-black"><h1>376 Mt Dangar Road</h1></div>
                        <div className="mx-1 text-gray-400"><h1>4386 ha</h1></div>

                    </div>

                </div>
            </div >
        </>
    )
}

export default TrackSales
